<template>
    <ImpedimentContainer
        title="HI-Problema de Audición"
    >
        <p><b>El estudiante presenta:</b></p>
        <TreeOptions
            v-model="optionsTree"
            :is-disabled="isDisabled"
            :show-error="showErrors && !isValid"
        />

        <div class="custom-control custom-checkbox mt-4">
            <input
                id="checkboxPartialDeafMultiple"
                v-model="innerModel.isPartialHearing"
                name="checkboxPartialDeafMultiple"
                type="checkbox"
                class="custom-control-input"
                :disabled="isDisabled"
            />
            <label
                for="checkboxPartialDeafMultiple"
                class="custom-control-label font regular"
            >
                Sordo Parcial
                <span v-if="innerModel.isPartialHearing != null">
                    <i class="ic-check" />
                </span>
            </label>
        </div>
    </ImpedimentContainer>
</template>
  
<script>
import TreeOptions from './options/TreeOptions.vue';
import ImpedimentMixin from './common/ImpedimentMixin';
import ImpedimentContainer from './common/ImpedimentContainer';

export default {
    name: 'ProblemaAudicion',
    mixins: [ImpedimentMixin],
    components: {
        TreeOptions,
        ImpedimentContainer
    },
    props: {
        value: {
            type: Object,
            default: () => ({
                isPartialHearing: null
            })
        },
    },
    data: () => ({
        innerModel: null,
        showErrors: false,
    }),
    methods: {
        validate() {
            this.showErrors = true;
            return this.isValid;
        }
    },
    computed: {
        isValid() {
            return this.isValidOptionsSelection;
        }
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newValue) {
                this.innerModel = newValue;
            }
        },
        innerModel: {
            deep: true,
            handler(newValue) {
                this.$emit('input', newValue);
            }
        },
    }
}
</script>